import { get } from 'utils/api';

export const getSMCGateway = (data) => {
  return get(`/util/smcgateway`, data);
};

export const smcGateway = {
  getSMCGateway,
};
